import {validateStatus} from "./helpers";
import {SERVICE_URL} from "./constants";
import axios from "axios/index";

export function getLogsByDeviceIdAPI(id) {
  
  return axios.get(`${SERVICE_URL}/${'logs'}/${id}`)
    .then(validateStatus(200))
    .then(response => response.data)
    .then(responseData => {
      console.info(`[api.helpers.getLogsByDeviceIdAPI(${'logs'})] response`, responseData);
      return responseData;
    });
}

export function getWetLogsByDeviceIdAPI(id) {
  
  return axios.get(`${SERVICE_URL}/${'logs/dryness'}/${id}`)
    .then(validateStatus(200))
    .then(response => response.data)
    .then(responseData => {
      console.info(`[api.helpers.getWetLogsByDeviceIdAPI(${'logs/dryness'})] response`, responseData);
      return responseData;
    });
}


// WEBPACK FOOTER //
// ./src/api/logAPI.js